import CourseForm from "./CourseForm";

export default function AddCourse() {
    return <CourseForm />;
}
